import { DocumentationValidatorResolver } from './DocumentationValidatorResolver'
import { PoxaDocumentValidator } from './PoxaDocumentValidator'
import { NegociadoDocumentValidator } from './NegociadoDocumentValidator'
import { AlleamentoDirectoDocumentValidator } from './AlleamentoDirectoDocumentValidator'
import { DisposicionDecimosextaDocumentValidator } from './DisposicionDecimosextaDocumentValidator'

export class DocumentationValidatorResolverProvider {
  provide (): DocumentationValidatorResolver {
    const validators = [
      new PoxaDocumentValidator(),
      new NegociadoDocumentValidator(),
      new AlleamentoDirectoDocumentValidator(),
      new DisposicionDecimosextaDocumentValidator()
    ]
    return new DocumentationValidatorResolver(validators)
  }
}
